import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL || '';

export default function TarjousPage({ backToBetaHome = false }) {
  const [earlyWormsPurchased, setEarlyWormsPurchased] = useState(0);

  useEffect(() => {
    fetch(`${API}/api/early-worm-status`)
      .then((res) => res.ok ? res.json() : Promise.reject(new Error('Failed to load tarjous status')))
      .then((data) => {
        const value = typeof data?.earlyWormsPurchased === 'number' ? data.earlyWormsPurchased : 0;
        setEarlyWormsPurchased(value);
      })
      .catch(() => {
        setEarlyWormsPurchased(0);
      });
  }, []);

  const remaining = Math.max(0, 600 - earlyWormsPurchased);

  let statusColor = 'green';
  if (remaining <= 100) {
    statusColor = 'red';
  } else if (remaining < 400) {
    statusColor = 'yellow';
  }

  return (
    <div className={`App-block${backToBetaHome ? ' App-block--tarjousBack' : ''}`}>
      {backToBetaHome ? (
        <a href="/beta-testaajaksi" className="TarjousPage-backCorner">
          ← Takaisin
        </a>
      ) : null}
      <div className="TarjousPage">
        <h1>EARLY WORM -60%</h1>
        <p>600 ensimmäiselle jäsenyys puoleen hintaan niin kauan, kuin jäsenyys kestää.</p>
        <p className='btw'>
          Jäsenyyden keskeyttäminen päättää tarjoushinnan.
        </p>
        <p className='btw'>
          Kampanjan jälkeen 15€/kk tai 150€/vuosi.
        </p>
        <div className="tarjous-status" style={{ color: statusColor }}>
          {remaining} / 600
        </div>
      </div>
    </div>
  );
}

